<template>
  <div v-if="$store.state.app.basics.modules.indexOf('jobs') > -1 && $store.state.items[$route.params.type][$route.params.iitemid].jobs" class="sub-container">
    <div class="flexy flex wrap align-center">
      <div class="flex align-center wrap">
        <span class="sm-font label flex column r8">
          <span>Help</span>
          <span>Wanted</span>
        </span>
        <b class="p8">{{$store.state.items[$route.params.type][$route.params.iitemid].jobs['job-title']}}</b>
      </div>
      
      <div class="flex wrap between flexy b8">
        <div class="flex xs-font between flexy" :key="statKey" v-for="(stat, statKey) in ['interested']">
          <div class="sub-container ">
            <code class="flex center wrap">{{$store.state.items[$route.params.type][$route.params.iitemid].jobs['job-type']}} {{$store.state.items[$route.params.type][$route.params.iitemid].jobs['job-type'] !== 'one-time' ? 'position' : 'opportunity'}}</code>
            <div class="flex around align-center md-font p4">
              <span class="r8">Pay</span>
              <div class="flex column align-center center">
                <b>{{$store.state.items[$route.params.type][$route.params.iitemid].jobs.pay}} {{$store.state.items[$route.params.type][$route.params.iitemid].jobs['pay-currency']}} per {{$store.state.items[$route.params.type][$route.params.iitemid].jobs['pay-schedule']}}</b>
              </div>
            </div>
            <div class="sm-font flex center wrap">
              <span v-if="$store.state.items[$route.params.type][$route.params.iitemid].jobs.seasonal">(Seasonal or temporary)</span>
            </div>
          </div>
          <div class="flex wrap column align-center p4">
            <div v-if="$store.state.jobs[jType] && $store.state.jobs[jType][jId]">
            <span class="r4" v-if="$store.state.jobs[jType] && $store.state.jobs[jType][jId]">{{$store.state.jobs[jType][jId][stat] ? $store.state.jobs[jType][jId][stat].length : 0}}</span>
            <b>{{stat.toUpperCase()}}</b>
          </div>
          <button 
            type="button" 
            :class="`p16 ${$store.state.related.jobs[$route.params.type] && $store.state.related.jobs[$route.params.type][$route.params.iitemid] === stat ? 'indicate' : ''}`" 
            :style="($store.state.jobs[jType] && $store.state.jobs[jType][jId] && $store.state.jobs[jType][jId][stat] && $store.state.jobs[jType][jId][stat].indexOf($store.state.auth.uid) > -1) ? 'font-weight: 600' : ''" 
            @click="attendJob($store.state.related.jobs[$route.params.type] && $store.state.related.jobs[$route.params.type][$route.params.iitemid] === stat ? '' : stat)"><i :class="`fas fa-${$store.state.related.jobs[$route.params.type] && $store.state.related.jobs[$route.params.type][$route.params.iitemid] === stat ? 'check-square' : 'square'} fa-2x`"></i></button>
          </div>
        </div>
      </div>

      <button class="xl-font align-center flex flexw update b16 p8" type="button"><i class="fas fa-paper-plane"></i> Apply Now</button>

      <div class="sub-container flexy">
        <b class="sm-font">Company</b>
        <div class="flex align-center b8" v-if="!$store.state.items[$route.params.type][$route.params.iitemid].jobs.telecommute">
          <span class="r8">{{$store.state.items[$route.params.type][$route.params.iitemid].jobs.company}}</span>
        </div><b class="sm-font">Location</b>
        <div class="flex align-center b8" v-if="!$store.state.items[$route.params.type][$route.params.iitemid].jobs.telecommute">
          <span class="r8">{{$store.state.items[$route.params.type][$route.params.iitemid].jobs.street}},</span>
          <span class="r8">{{$store.state.items[$route.params.type][$route.params.iitemid].jobs.city}},</span>
          <span class="r8">{{$store.state.items[$route.params.type][$route.params.iitemid].jobs.country}}</span>
        </div>
        <div class="flex align-center b8" v-else>Work from anywhere</div>
        <b class="sm-font">Details</b>
        <div class="flex align-center b8">
          <span class="r8">{{$store.state.items[$route.params.type][$route.params.iitemid].jobs.responsibilities}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    name () { return 'attend' },
    status () {
      return this.$store.dispatch('query', {
        type: 'job',
        id: this.jId || this.$route.params.iitemid,
        itemType: this.jType
      })
    }
  },
  methods: {
    attendJob (stat) {
      var relateObj = {
        secret: (this.$store.state.jobs[this.jType] && this.$store.state.jobs[this.jType][this.jId]) ? this.$store.state.items[this.jType][this.jId].secret : false,
        status: stat,
        type: 'jobs',
        id: this.jId,
        itemType: this.jType
      }
      this.$store.dispatch('relate', relateObj)
    }
  },
  mounted () {
    this.$store.dispatch('query', {
      type: 'job',
      itemType: this.jType,
      id: this.jId || this.$route.params.iitemid
    })
  },
  props: {'jId': {type: String}, 'jType': {type: String}}
}
</script>